module.exports = __webpack_public_path__ + "img/neck opening.3fe24542.png";